import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { showToast } from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';
import ROUTES from 'consts/routing';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import TemplatesList from 'components/Templates/TemplatesList';
import { OrgnizationTemplatesType } from 'store/modules/organizations/organizations';
import api from 'api/api';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { connect, selectors, actions } = StoreProvider;

interface ExtendedTemplateProps {
  templates: OrgnizationTemplatesType;
  setTemplates: (payload: any) => void;
}

const Templates = ({
  history,
  templates,
  setTemplates,
  location,
}: RouteComponentProps & ExtendedTemplateProps) => {
  const parsedSearch = queryString.parse(location.search);
  const t = useFormatMessage();

  useEffect(() => {
    if (parsedSearch.action === 'template_created') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.created', 'Template created'),
      });
    }
    if (parsedSearch.action === 'template_edited') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.edited', 'Template edited'),
      });
    }
    if (parsedSearch.action === 'template_deleted') {
      showToast({
        type: 'info',
        title: t('dashboard.templates.deleted', 'Template deleted'),
      });
    }

    api.resources
      .getTemplates(
        parsedSearch as {
          limit: string;
          offset: string;
        }
      )
      .then(({ data }) => {
        setTemplates(data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.key]);

  const removeTemplate = (id: number) => {
    api.resources
      .removeTemplate(id)
      .then(() =>
        history.push(
          `${ROUTES.ADMIN.TEMPLATES.SURVEYS.MAIN}?action=template_deleted`
        )
      )
      .catch(() => {
        showToast({
          type: 'error',
          title: t(
            'errors.toast.general',
            'Something went wrong, please contact administrator'
          ),
        });
      });
  };

  const getPageNumber = () => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return parseInt(parsedSearch.offset, 10) / 20 + 1;
    }

    return 0;
  };

  return (
    <Dashboard title="Templates Surveys" location={location}>
      <AdminMenu />

      <Grid container>
        <TemplatesList
          list={templates.list}
          count={templates.count}
          currentPage={getPageNumber()}
          removeTemplate={removeTemplate}
          singleUrl={ROUTES.ADMIN.TEMPLATES.SURVEYS.MAIN}
          createUrl={ROUTES.ADMIN.TEMPLATES.SURVEYS.CREATE}
        />
      </Grid>
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    templates: selectors.organizationsSelectors.templates(state),
  }),
  {
    setTemplates: actions.organizationsActions.setTemplates,
  }
)(Templates);
